import { Injectable } from '@angular/core';

/** Empty implementation that is needed for Advanced Dropdown */

@Injectable({
    providedIn: 'root'
})
export class TabService {
    public static $name = 'tabService';
    public selectedIndex: number = 1;
    public getCurrentIndex(): number {
        return this.selectedIndex;
    }
}
